import router from "@/router";
import store from "@/store";
import config from "@/config";
import { DO_ROUTE } from "@/config/constants/action-types";

describe("Router", () => {
  it("scrollBehavior returns { x: 0, y: 0 }", () => {
    const scrollBehavior = router.options.scrollBehavior;

    const result = scrollBehavior();

    expect(result).toEqual({ x: 0, y: 0 });
  });

  it("beforeEach navigation guard", async () => {
    const to = "testName";
    const next = jest.fn();

    config.getPasoProperties = jest.fn().mockReturnValue(null);
    store.dispatch = jest.fn();

    await router.push(to);
    expect(config.getPasoProperties).toHaveBeenCalledWith(null);
    expect(store.dispatch).toHaveBeenCalledWith(
      DO_ROUTE,
      expect.objectContaining({ fullPath: "/testName" })
    );
    expect(next).toHaveBeenCalledTimes(0);
  });
});